import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { apiClient } from './client';
import type { DashboardResponse } from '@/types/api';

interface DashboardParams {
  period: 'day' | 'week' | 'month' | 'year';
  date: string; // YYYY-MM-DD
}

export function useDashboardKpi(params: DashboardParams) {
  return useQuery({
    queryKey: ['dashboard', 'kpi', params.period, params.date],
    queryFn: async () => {
      const res = await apiClient.get<DashboardResponse>('/dashboard/kpi', {
        params: { period: params.period, date: params.date },
      });
      return res.data;
    },
    staleTime: 120 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}

export function useDashboardDefaultDate(): string {
  return dayjs().format('YYYY-MM-DD');
}
